// extracted by mini-css-extract-plugin
export default {"container":"ProfileHome_container__tPLzL","main-image":"ProfileHome_main-image__Sjnk8","content":"ProfileHome_content__PYhFi","email":"ProfileHome_email__RLwfK"};